import * as React from "react";

function ChooseUpgrade(props){
  return(
  <div className="container">
    <div className="row" style={{paddingTop:'50px'}}>
      <a href="https://marketingchartec.clickfunnels.com/core-membership1615931233456" target="_blank" rel="noopener noreferrer">
        <img src={'https://chartec-core-public.s3-us-west-1.amazonaws.com/core_memberships_upgradepage5.jpg'} style={{width: "100%",position: "absolute",left: "0"}}/>
      </a>
      {/* <a href="/upgrade?product_id=1"><div className="col-xs-5" style={{height : "105vh"}}></div></a>
      <a href="/upgrade?product_id=2"><div className="col-xs-5" style={{height : "105vh"}}></div></a> */}
    </div>
  </div>
  )
}

export default ChooseUpgrade


// WEBPACK FOOTER //
// ./app/javascript/components/pages/ChooseUpgrade.tsx